import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { RestApiService } from "../shared/restApiServices/restapi.service";
import { RenderZingChartService } from "../shared/services/render.zingchart.service";

@Component({
  selector: 'app-response-chart',
  templateUrl: './response-chart.component.html',
  styleUrls: ['./response-chart.component.css']
})
export class ResponseChartComponent implements OnInit {

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(@Inject(MAT_DIALOG_DATA) public selectedQnr, private restApiService: RestApiService, private createChart: RenderZingChartService) {
  }

  ngOnInit() {
    this.getChartData('date');
  }

  onTypeSelection(event){
    this.getChartData(event.value);
  }

  getChartData(typeParam){
    this.restApiService.getDateUserWiseSurveyCountService(this.selectedQnr.qID, this.selectedQnr.adminID, typeParam).subscribe(result => {
      if (result.length > 0) {
        let dataChart = [];
        let chartValue = { "values": [] };
        let xLabels = [];
        for (let data in result) {
          chartValue.values.push(parseInt(result[data]['count']));
          let date = new Date(result[data]['property']);
          if(typeParam == 'date'){
            xLabels.push(date.getDate() + " " + this.months[date.getMonth()]);
          }
          else{
            xLabels.push(result[data]['property']);
          }
        }
        dataChart.push(chartValue);
        this.createChart.responseBarChart(dataChart, xLabels, 'responseChart');
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/response-chart-dialog/response-chart.component.ts